<script setup lang="ts">
import { computed } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';

export interface Props {
  isMini?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isMini: false,
});

const toggleSideBarIcon = computed(() => {
  return props.isMini ? 'mdi-arrow-collapse-right' : 'mdi-arrow-collapse-left';
});
</script>

<template>
  <KBtn
    :class="[$style.toggleBtn, { [$style.isMini]: props.isMini }]"
    variant="text"
    :prepend-icon="toggleSideBarIcon"
    data-testid="sideMainBarToggleBtn"
  >
    Hide sidebar
  </KBtn>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.toggleBtn {
  height: variables.$tableFooterHeight - 1px !important;
  width: 100% !important;

   &.isMini {
    :global {
      .v-btn__prepend {
        grid-area: content;
        justify-content: center;
        margin: 0;
      }
      .v-btn__content {
        display: none;
      }
    }
  }
}
</style>
